import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getAssessmentReportPage } from '../../redux/actions/assessment'
import AssessmentReportDynamicWidgets from '../../widgets/assessment/AssessmentReportDynamicWidgets'

export default function ReprotCompetenciesAssessment() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentReportPage(4, 1, 5)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <AssessmentReportDynamicWidgets schema={schema} type={4} />}
    </SidebarProposal>
  )
}

const mocSchema = {
  header: 'รายงานสมรรถนะตามโจทย์การประเมิน',
  searchForm: [
    {
      name: 'budgetYear',
      label: 'ปีงบประมาณ',
      type: '1',
    },
    {
      name: '',
      label: '',
      type: '',
    },
  ],
  resultData: {
    columnConfig: [
      {
        key: 'budgetYear',
        label: 'ปีงบประมาณ',
        width: 120,
        align: 'center',
        seq: 1,
      },
      {
        key: 'question',
        label: 'โจทย์ประเมินหลักที่',
        width: 120,
        align: 'center',
        seq: 1,
      },
      {
        key: 'subQuestion',
        label: 'โจทย์ประเมินย่อยที่',
        align: 'center',
        width: 120,
        seq: 1,
      },
      {
        key: 'evaluationRange',
        label: 'ช่วงของการประเมินผล',
        width: 300,
        seq: 1,
      },
      {
        key: 'evaluationElement',
        label: 'องค์ประกอบของการประเมินผล',
        width: 300,
        seq: 1,
      },
      {
        key: 'subQuestionDesc',
        label: 'รายละเอียดโจทย์ประเมินย่อย',
        align: 'center',
        width: 350,
        seq: 1,
      },
      {
        key: 'evaluationCriteria',
        label: 'เกณฑ์การประเมิน',
        align: 'right',
        width: 350,
        seq: 1,
      },
      {
        key: 'moreDesc',
        label: 'คำอธิบายเพิ่มเติมหรือข้อมูลประกอบการพิจารณาและประเมินผล',
        align: 'center',
        width: 350,
        seq: 1,
      },
      {
        key: 'subQuestionWeight',
        label: 'ค่าน้ำหนักโจทย์ย่อย',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'unitScore',
        label: 'ค่าคะแนนหน่วยจัดการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'processScore',
        label: 'ประมวลผลคะแนน',
        width: 200,
        seq: 1,
      },
      {
        key: 'qualitativeData',
        label: 'ข้อมูลเชิงคุณภาพในการอธิบายหรือให้รายละเอียดเพิ่มเติม',
        width: 200,
        seq: 1,
      },
      {
        key: 'evaluationTeamReflect',
        label: 'สิ่งที่ทีมประเมินสะท้อน/จัดกระบวนการพัฒนาเพิ่มเติมให้แก่หน่วยจัดการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'modification',
        label: 'ความเปลี่ยนแปลงที่เกิดขึ้น',
        width: 200,
        seq: 1,
      },
    ],
    total: 2,
    values: [
      {
        rowNum: 1,
        budgetYear: '1',
        question: '2',
        subQuestion: '3',
        evaluationRange: '2025',
        evaluationElement: 100000,
        subQuestionDesc: '',
        evaluationCriteria: '',
        moreDesc: '',
        subQuestionWeight: '',
        unitScore: '',
        processScore: '',
        qualitativeData: '',
        evaluationTeamReflect: '',
        modification: '',
      },
      {
        rowNum: 1,
        budgetYear: '1',
        node: '1',
        projectCode: '2',
        projectName: '3',
        region: '2025',
        province: 100000,
        district: '',
        subDistrict: '',
        addressName: '',
        issue: '',
        projectLeader: '',
        targetGroupPerson: '',
        targetGroupHousehold: '',
        behavioralChangePerson: '',
        behavioralChangeHousehold: '',
        environmentSociety: 20,
        environmentPhysical: 10,
        innovationPrototypeArea: 10,
      },
    ],
  },
}
